var map = {
	"./active-btn.webp": 2515,
	"./angbao-bonus-thaipusam.webp": 2516,
	"./angbao-bonus.webp": 2517,
	"./angbao-bonus_dewali.webp": 2518,
	"./cny-lucky-draw.webp": 2519,
	"./cny-promo.webp": 2520,
	"./dewali-promo.webp": 2521,
	"./fifa-prediction.webp": 2522,
	"./fifa-qna.webp": 2523,
	"./raya-promo.webp": 2524,
	"./welcome-cny-bonus.webp": 2525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2514;